import React from "react";
import { motion } from "framer-motion";

const InfiniteScroll = () => {
  const logosRow1 = [
    "/logos/baker-fcs-corporate-logo-2.webp",
    "/logos/eastcoast.png", 
    "/logos/gemaire.png",
    "/logos/gormangormanwhitesmall.png",
    "/logos/jsc.png",
    "/logos/logo-hvac.png",
    "/logos/logo.png",
  ];

  const logosRow2 = [
    "/logos/Mingledorff.png",
    "/logos/new-logo-2017.png", 
    "/logos/pt-logo-for-white-bg.png",
    "/logos/screen.png",
    "/logos/southern-pipe-and-supply-logo.png",
    "/logos/SSD-Logo.png",
    "/logos/supplyjouse.png",
    "/logos/woodson.png"
  ];

  // Create triple copies to ensure seamless looping
  const duplicatedLogos1 = [...logosRow1, ...logosRow1, ...logosRow1];
  const duplicatedLogos2 = [...logosRow2, ...logosRow2, ...logosRow2];

  const popAnimation = {
    scale: [1, 1.2, 1],
    transition: {
      duration: 0.5,
      repeat: Infinity,
      repeatDelay: Math.random() * 5 + 2
    }
  };

  return (
    <div className="overflow-hidden border-b-2 border-yellow-400 bg-white py-10">
      {/* First Row */}
      <div className="relative">
        <motion.div 
          className="flex whitespace-nowrap"
          animate={{ 
            x: [0, '-33.33%']
          }}
          transition={{
            x: {
              duration: 20,
              repeat: Infinity,
              ease: "linear",
              repeatType: "mirror"
            }
          }}
        >
          {duplicatedLogos1.map((logo, index) => (
            <motion.div 
              key={index} 
              className="flex-shrink-0 mx-4 px-4"
              animate={index % 3 === 0 ? popAnimation : {}}
            >
              <img src={logo} alt={`Logo ${index}`} className="md:h-16 h-10 object-contain" />
            </motion.div>
          ))}
        </motion.div>
      </div>

      {/* Second Row */}
      <div className="relative mt-20">
        <motion.div 
          className="flex whitespace-nowrap"
          animate={{ 
            x: ['-33.33%', 0]
          }}
          transition={{
            x: {
              duration: 20,
              repeat: Infinity,
              ease: "linear",
              repeatType: "mirror"
            }
          }}
        >
          {duplicatedLogos2.map((logo, index) => (
            <motion.div 
              key={index} 
              className="flex-shrink-0 mx-4 px-4"
              animate={index % 4 === 0 ? popAnimation : {}}
            >
              <img src={logo} alt={`Logo ${index}`} className="md:h-16 h-10 object-contain" />
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default InfiniteScroll;
